export const FILE_INPUT_BROWSE_BUTTON_CLASS = 'btn btn-primary';
export const FILE_INPUT_TOOLBAR_BUTTON_CLASS = 'btn btn-secondary';
export const FILE_INPUT_PREVIEW_ACTION_BUTTON_CLASS = 'btn btn-sm btn-kv btn-default btn-outline-secondary';
export const FILE_INPUT_PREVIEW_ERROR_ACTION_BUTTON_CLASS = 'btn btn-sm btn-kv btn-danger';
export const FILE_INPUT_DANGER_BUTTON_CLASS = 'btn btn-danger';
export const FILE_INPUT_HIDDEN_ACTION_CLASS = 'd-none';

function lucideIcon(name: string, className = ''): string {
    const classAttribute = className ? ` class="${className}"` : '';

    return `<i data-lucide="${name}"${classAttribute} aria-hidden="true"></i>`;
}

export function getFileInputIconOptions() {
    return {
        browseIcon: lucideIcon('folder-open') + ' ',
        removeIcon: lucideIcon('trash-2') + ' ',
        cancelIcon: lucideIcon('ban') + ' ',
        pauseIcon: lucideIcon('pause') + ' ',
        uploadIcon: lucideIcon('upload') + ' ',
        msgValidationErrorIcon: lucideIcon('circle-alert') + ' ',
        previewFileIcon: lucideIcon('file'),
        previewZoomButtonIcons: {
            prev: lucideIcon('chevron-left'),
            next: lucideIcon('chevron-right'),
            rotate: lucideIcon('rotate-cw'),
            toggleheader: lucideIcon('arrow-up-down'),
            fullscreen: lucideIcon('maximize'),
            borderless: lucideIcon('external-link'),
            close: lucideIcon('x'),
        },
        fileActionSettings: {
            removeIcon: lucideIcon('trash-2'),
            uploadIcon: lucideIcon('upload'),
            uploadRetryIcon: lucideIcon('cloud-upload'),
            downloadIcon: lucideIcon('download'),
            rotateIcon: lucideIcon('rotate-cw'),
            zoomIcon: lucideIcon('search'),
            dragIcon: lucideIcon('grip-vertical'),
            indicatorNew: lucideIcon('circle-plus', 'text-warning'),
            indicatorSuccess: lucideIcon('circle-check', 'text-success'),
            indicatorError: lucideIcon('circle-alert', 'text-danger'),
            indicatorLoading: lucideIcon('loader-circle', 'text-muted'),
            indicatorPaused: lucideIcon('circle-pause', 'text-info'),
        },
        layoutTemplates: {
            fileIcon: lucideIcon('file', 'kv-caption-icon') + ' ',
        },
    };
}

type FileInputLayoutOptions = {
    crop?: boolean;
    drag?: boolean;
    metadata?: boolean;
    restore?: boolean;
};

function getActionsTemplate(options: FileInputLayoutOptions): string {
    const dragAction = options.drag === false ? '' : '        {drag}\n';
    const cropAction = options.crop
        ? '        <button type="button" class="kv-file-crop ' + FILE_INPUT_PREVIEW_ACTION_BUTTON_CLASS + '" title="Ořezat obrázek" style="display:none;"><i data-lucide="crop"></i></button>\n'
        : '';
    const restoreAction = options.crop && options.restore !== false
        ? '        <button type="button" class="kv-file-restore ' + FILE_INPUT_PREVIEW_ACTION_BUTTON_CLASS + '" title="Obnovit původní" style="display:none;"><i data-lucide="undo-2"></i></button>\n'
        : '';
    const metadataAction = options.metadata
        ? '        <button type="button" class="kv-file-metadata ' + FILE_INPUT_PREVIEW_ACTION_BUTTON_CLASS + '" title="Popisek a alt text" style="display:none;"><i data-lucide="pen"></i></button>\n'
        : '';

    return '<div class="file-actions">\n' +
        '    <div class="file-footer-buttons">\n' +
        dragAction +
        cropAction +
        restoreAction +
        metadataAction +
        '        {delete} {zoom} {other}\n' +
        '    </div>\n' +
        '</div>\n' +
        '<div class="clearfix"></div>';
}

function getFooterTemplate(): string {
    return '<div class="file-thumbnail-footer">\n' +
        '  <div class="file-footer-caption" title="{caption}">\n' +
        '    <div class="file-caption-info">{caption}</div>\n' +
        '    <div class="file-size-info">{size}</div>\n' +
        '  </div>\n' +
        '  {progress}\n' +
        '  {indicator}\n' +
        '  {actions}\n' +
        '</div>';
}

export function getFileInputLayoutTemplates(options: FileInputLayoutOptions): Record<string, string> {
    const templates: Record<string, string> = {
        ...getFileInputIconOptions().layoutTemplates,
        actions: getActionsTemplate(options),
        actionDrag: '<button type="button" class="file-drag-handle {dragClass}" title="{dragTitle}">{dragIcon}</button>',
    };

    if (options.metadata) {
        templates.footer = getFooterTemplate();
    }

    return templates;
}
